import HomePage from "@/pages/HomePage";
import React from "react";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import LoginPage from "@/pages/LoginPage";
import BoardPackPage from "@/pages/BoardPackPage";
import CubePage2 from "@/pages/CubePage_2";
import MdxServerPage from "@/pages/MdxServerPage";
import OnStreetMap from "@/pages/OnStreetMap";
import NotFoundPage from "@/pages/NotFoundPage";
import UserManagementPage from "@/pages/UserManagementPage";
import RoleManagementPage from "@/pages/RoleManagementPage";
import PermissionManagementPage from "@/pages/PermissionManagementPage";
import AssignPermissionPage from "@/pages/AssignPermissionPage";
import BoardPackConfiguration from "@/pages/BoardPackConfiguration";
import ProfilePage from "@/pages/Profilepage";
import BoardPackPageMobile from "@/pages/BoardPackPageMobile";
import Mobile from "@/pages/Mobile";
import FinancialDashboard from "@/pages/FinancialDashboard";
import FinalizedBoardPack from "@/pages/FinalizedBoardPack";
import OffStreetMap from "@/pages/OffStreetPage";
import AccessControlPage from "@/pages/AccessControlPage";
import MappingPage from "@/pages/MappingPage";
import OnStreetMasterData from "@/pages/OnStreetMasterData";
import LocationPickerPage from "@/pages/LocationPickerPage";
import OffSTreetMasterData from "@/pages/OffSTreetMasterData";
import OffStreetAddPage from "@/pages/OffStreetAddPage";
import BoardPackRenderPage from "@/pages/BoardPackRenderPage";


const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Server-side render worker only (backend repo, report-worker/) — no sidebar, no permissions */}
      <Route path="/board-pack-render" element={<BoardPackRenderPage />} />

      <Route element={<ProtectedRoute />}>
        {/* <Route path="/" element={<HomePage />} /> */}
        <Route path="/user" element={<UserManagementPage />} />
        <Route path="/role" element={<RoleManagementPage />} />
        <Route path="/permission" element={<PermissionManagementPage />} />
        <Route path="/assign-permission" element={<AssignPermissionPage />} />
        <Route path="/board-pack" element={<BoardPackPage />} />
        <Route path="/board-pack-config" element={<BoardPackConfiguration />} />
        <Route path="/cube" element={<CubePage2 />} />
        <Route path="/instance" element={<MdxServerPage />} />
        <Route path="/on-street-overview" element={<OnStreetMap />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/board-pack-mobile" element={<BoardPackPageMobile />} />
        <Route path="/mobile" element={<Mobile />} />
        <Route path="/" element={<FinancialDashboard />} />
        <Route path="/finalized-boardpacks" element={<FinalizedBoardPack />} />
        <Route path="/off-street-overview" element={<OffStreetMap />} />
        <Route path="/access-control" element={<AccessControlPage />} />
        <Route path="/mapping" element={<MappingPage />} />
        <Route path="/on-street-master-data" element={<OnStreetMasterData />} />
        <Route path="/location-picker" element={<LocationPickerPage />} />
        <Route path="/off-street-master-data" element={<OffSTreetMasterData />} />
        <Route path="/off-street-add" element={<OffStreetAddPage/>} />   {/* ← ye line add karo */}
        <Route
          path="*"
          element={
            <><NotFoundPage /></>
          }
        />
      </Route>
    </Routes>
  );
};

export default AppRoutes;